import { render } from "./TemplateSelectorV2.vue?vue&type=template&id=bec0e2e6&scoped=true"
import script from "./TemplateSelectorV2.vue?vue&type=script&lang=ts"
export * from "./TemplateSelectorV2.vue?vue&type=script&lang=ts"

import "./TemplateSelectorV2.vue?vue&type=style&index=0&id=bec0e2e6&scoped=true&lang=scss"
import "./TemplateSelectorV2.vue?vue&type=style&index=1&id=bec0e2e6&lang=scss"
script.render = render
script.__scopeId = "data-v-bec0e2e6"

export default script